import { render } from "./HeroiconsSolidSelector.vue?vue&type=template&id=e4eaa82e"
const script = {}

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidSelector.vue"]])

export default __exports__